import facebook_icon from "../../../Images/facebook_icon.png";
import insta_icon from "../../../Images/insta_icon.png";
import linkedin_icon from "../../../Images/linkedin_icon.png";

const SocialMediaComponent = ({ data }) => {
    return (
        <div className="uploadbannerblmdiv">
            <div className="uploadbannerdivnewmain">
                <div className="consttactdetatlsarroedyrdiv">
                    <p className="cinnattddttdtsttspo">Social links</p>
                </div>
                <div className="fallsebblldivmaindivflxl">
                    <div className="fallsebblldivmain">
                        <div className="icopndibimahhmainimjh">
                            <a href={data?.businessFacebookLink} target="_blank"><img src={facebook_icon} alt={`${data?.companyName} Facebook link`} title={`${data?.companyName} Facebook link`} /></a>
                        </div>
                        <p className="faccevttxttpphhtxtpp">Facebook </p>

                    </div>
                    <div className="fallsebblldivmain">
                        <div className="icopndibimahhmainimjh">
                            <a href={data?.businessInstaLink} target="_blank"><img src={insta_icon} alt={`${data?.companyName} Instagram link`} title={`${data?.companyName} Instagram link`} /></a>
                        </div>
                        <p className="faccevttxttpphhtxtpp">Instagram</p>
                    </div>
                    <div className="fallsebblldivmain">
                        <div className="icopndibimahhmainimjh">
                            <a href={data?.businessLinkedInLink} target="_blank"><img src={linkedin_icon} alt={`${data?.companyName} LinkedIn link`} title={`${data?.companyName} LinkedIn link`} /></a>
                        </div>
                        <p className="faccevttxttpphhtxtpp">Linkedin</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SocialMediaComponent;